import {AllowPrivateMessages} from "./user";

export type ThemeMode = 'light' | 'dark' | 'system';
export interface ClientSettingsModel {
    notifications_v2: Array<NotificationClientSettings>,
    pictures: boolean
    serviceMessages: boolean,
    allowPrivateMessages: AllowPrivateMessages,
    usersSorting: UsersSorting,
    watermark: boolean,
    themeMode: ThemeMode,
    boostInUsersList: boolean,
}

export enum NotificationClientSettings {
    mainRoom = 'main_room',
    otherRooms = 'other_rooms',
    personalRooms = 'personal_rooms',
    answers = 'answers'
}

export enum UsersSorting {
    girls = 'girls',
    boys = 'boys',
    trans = 'trans',
    registered = 'registered',
    guests = 'guests',
    alphabetic_desc = 'alphabetic_desc',
    alphabetic_asc = 'alphabetic_asc',
}